import { Navigate, Route, Routes } from 'react-router-dom'
import { getHubToken } from './api'
import LoginPage from './pages/LoginPage'
import WorkspacesPage from './pages/WorkspacesPage'

function RequireHub({ children }) {
  if (!getHubToken()) return <Navigate to="/" replace />
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/workspaces"
        element={
          <RequireHub>
            <WorkspacesPage />
          </RequireHub>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
